import { Paper, Typography } from '@mui/material'
import { Box } from '@mui/system'
import Logo from 'common/components/Logo'
import useQuery from 'common/hooks/useQuery'
import { selectPortal } from 'features/portal/portalSlice'
import i18n from 'lang/idiomas'
import { useSelector } from 'react-redux'
import ThemeManager from 'theming/ThemeManager'
import DefaultLoginBackGround from '../components/LoginBackground'
import PasswordForm from '../components/PasswordForm'

const ResetPassword = () => {
  const themeManager = new ThemeManager()
  const query = useQuery()

  const portal = useSelector(selectPortal)

  const themeController = new ThemeManager()
  const LoginBackground = themeController?.components
    ? (themeController?.components['LoginBackground'] ?? DefaultLoginBackGround)
    : DefaultLoginBackGround

  const logoOutside = themeManager.options.loginLogoOutside ?? false

  return (
    <LoginBackground loading={false}>
      <Box
        className="recover-password-container"
        sx={{
          width: {
            xs: '100%',
            md: '60%',
          },
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        {logoOutside ? (
          <Logo
            logoType="Large"
            sx={{
              mb: 5,
              transfor: 'translateX(-30%)',
            }}
          />
        ) : (
          <></>
        )}

        <>
          <Logo
            logoType="Large"
            sx={{
              m: {
                xs: 'auto',
                md: '10px 0px 50px 0px',
              },
              my: 5,
              width: {
                xs: '70%',
                md: '30%',
              },
            }}
          />
          <Typography
            variant="h4"
            sx={{
              fontWeight: '100',
              color: 'primary.main',
              mt: { xs: 2, md: 4 },
              mb: { xs: 3, md: 5 },
              textAlign: { xs: 'center', md: 'unset' },
              fontSize: {
                xs: '1.75rem',
              },
            }}
          >
            {portal?.portal?.descripcion ?? 'Portal del Empleado'}
          </Typography>
        </>

        <Paper
          className="inicio"
          sx={{
            backgroundColor: 'background.paper',
            color: 'text.primary',
            p: { xs: 2, sm: 3, md: 4 },
            width: { md: '100%' },
          }}
        >
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            <Typography variant="h6" sx={{ m: 2 }} align="center">
              {i18n.t('login.esnucont', { defaultValue: 'ESTABLECER NUEVA CONTRASEÑA' })}
            </Typography>
          </div>

          <Box className="set-new-password-form">
            <PasswordForm token={query.get('t')} buttonWidth="100%" variant="standard" />
          </Box>
        </Paper>
      </Box>
    </LoginBackground>
  )
}

export default ResetPassword
